var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block quote"},[_c('blockquote',{style:({ color: _vm.$getField('quote_text_colour', _vm.data) }),domProps:{"innerHTML":_vm._s(_vm.$getField('quote_text', _vm.data))}}),_vm._v(" "),_c('p',{staticClass:"cite",style:({ color: _vm.$getField('quote_cite_colour', _vm.data) })},[_vm._v(_vm._s(_vm.$getField('quote_cite', _vm.data)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35191b68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Projects/Rows/Quote.vue
// module id = X1zd
// module chunks = 8